import { Component, Input, OnInit } from "@angular/core";
import { DatePipe, DecimalPipe, NgClass } from "@angular/common";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { AlertComponent } from "../../../../../components/alert/alert.component";
import { downloadJSONAsExcel, safeParseFloat } from "../../../../../../../../shared/src/lib/utils/common";
import { TranslateModule } from "@ngx-translate/core";
import { NgxPrintDirective } from "ngx-print";

@Component({
  selector: "app-pl-detail",
  imports: [MatProgressBarModule, DecimalPipe, MatIconModule, MatButtonModule, AlertComponent, DatePipe, TranslateModule, NgClass, NgxPrintDirective],
  providers: [DatePipe],
  templateUrl: "./pl-detail.component.html",
  styleUrls: ["./pl-detail.component.scss", "../../report.scss"],
})
export class PlDetailComponent implements OnInit {
  @Input() details: any[] = [];
  @Input() totalCommission: number = 0;
  columns = ["Selection", "Bet Id", "Odds", "Price", "Stake", "Side", "Placed", "Matched", "Profit/Loss"];
  footerRows: { label: string; value: any }[] = [];

  constructor(private datePipe: DatePipe) {}

  ngOnInit() {
    this.prepareFooterRows();
  }

  prepareFooterRows() {
    this.footerRows = [
      { label: "Back Subtotal", value: this.backSubtotal },
      { label: "Lay Subtotal", value: this.laySubtotal },
      { label: "Market Subtotal", value: this.marketSubtotal },
      { label: "Commission", value: this.totalCommission },
      { label: "Net Market Total", value: this.netMarketTotal },
    ];
  }

  get backSubtotal() {
    return this.details
      .filter((item) => ["BACK", "UNDER"].includes(item.SIDE))
      .reduce((acc, item) => {
        const profit = item.PROFIT;
        return acc + safeParseFloat(profit);
      }, 0);
  }

  get laySubtotal() {
    return this.details
      .filter((item) => ["LAY", "OVER"].includes(item.SIDE))
      .reduce((acc, item) => {
        const profit = item.PROFIT;
        return acc + safeParseFloat(profit);
      }, 0);
  }

  get marketSubtotal() {
    return this.backSubtotal + this.laySubtotal;
  }

  get netMarketTotal() {
    return this.marketSubtotal + this.totalCommission;
  }

  prepareDataForExcel(details: any[], columns: string[], totals: any) {
    const dataForExcel = details.map((detail) => ({
      Selection: detail?.RUNNER_NAME,
      Odds: detail?.AVG_ODDS,
      Stake: detail?.SIZE,
      Side: detail?.SIDE,
      Placed: this.datePipe.transform(detail?.PLACED_ON, "M/d/yyyy H:mm"),
      Matched: this.datePipe.transform(detail?.SETTLED_ON, "M/d/yyyy H:mm"),
      "Profit/Loss": detail?.PROFIT,
    }));

    const emptyFields = {
      Selection: "",
      Odds: "",
      Stake: "",
      Side: "",
      Placed: "",
      Matched: "",
    };

    const totalKeys = [
      { key: "backSubtotal", label: "Back Subtotal" },
      { key: "laySubtotal", label: "Lay Subtotal" },
      { key: "marketSubtotal", label: "Market Subtotal" },
      { key: "totalCommission", label: "Commission" },
      { key: "netMarketTotal", label: "Net Market Total" },
    ];

    totalKeys.forEach((total) => {
      dataForExcel.push({
        ...emptyFields,
        Matched: total.label,
        "Profit/Loss": totals[total.key],
      });
    });

    return dataForExcel;
  }

  handleDownload() {
    const totals = {
      backSubtotal: this.backSubtotal,
      laySubtotal: this.laySubtotal,
      marketSubtotal: this.marketSubtotal,
      totalCommission: this.totalCommission,
      netMarketTotal: this.netMarketTotal,
    };
    const excelData = this.prepareDataForExcel(this.details, this.columns, totals);
    downloadJSONAsExcel(excelData, "betting profit & loss detail report");
  }

  protected readonly Array = Array;
}
